import canAccess from './canAccess';
import createCanAccess from './createCanAccess';

export { canAccess, createCanAccess };